import React, { useState } from 'react';

export default function DemoBookingSite() {
  const [selectedPackage, setSelectedPackage] = useState('grand_slam');
  const [anglersCount, setAnglersCount] = useState(2);
  const [arrivalDate, setArrivalDate] = useState('2026-10-15');
  const [departureDate, setDepartureDate] = useState('2026-10-19');
  const [targetSpecies, setTargetSpecies] = useState('tiger_fish');
  const [boatType, setBoatType] = useState('jet_boat');
  
  // Guest pre-registration names for TrophyCoin keepsakes
  const [guestNames, setGuestNames] = useState([
    'John Doe',
    'Michael Smith'
  ]);
  const [contactEmail, setContactEmail] = useState('john.doe@example.com');
  const [contactPhone, setContactPhone] = useState('+1 (555) 234-5678');
  const [specialRequests, setSpecialRequests] = useState('Interested in fly fishing for tiger fish on day two.');
  
  const [showConfirmation, setShowConfirmation] = useState(false);

  const packages = {
    grand_slam: {
      name: 'The 4-Day Grand Slam Angler',
      pricePerAngler: 2850,
      nights: 4,
      charterDays: 3,
      description: 'Our flagship all-inclusive expedition. 3 full days of master-guided jet boat charters, riverfront master suite, all gourmet meals, and an engraved metallic TrophyCoin keepsake for every angler in your party.',
      badge: 'Most Popular Package'
    },
    wilderness_float: {
      name: 'The Weekend Wilderness Float',
      pricePerAngler: 1450,
      nights: 2,
      charterDays: 1,
      description: 'Ideal quick retreat. 2 nights rustic luxury timber cabin lodging, 1 full-day canyon drift boat charter, gourmet river picnic, and certified TrophyCoin catch cards.',
      badge: 'Weekend Getaway'
    },
    lodge_buyout: {
      name: 'Exclusive Private Lodge Buyout',
      pricePerAngler: 4200,
      nights: 4,
      charterDays: 4,
      description: 'Total private run of the lodge for your group (up to 8 anglers). Full private skipper fleet, custom chef tasting menus, private helicopter fly-out day, and custom minted gold-plated TrophyCoins.',
      badge: 'VIP Corporate / Family'
    }
  };

  const handleAnglerCountChange = (count) => {
    const num = Math.max(1, Math.min(8, count));
    setAnglersCount(num);
    const newNames = [...guestNames];
    while (newNames.length < num) {
      newNames.push(`Angler #${newNames.length + 1}`);
    }
    setGuestNames(newNames.slice(0, num));
  };

  const handleNameChange = (index, value) => {
    const updated = [...guestNames];
    updated[index] = value;
    setGuestNames(updated);
  };

  const pkg = packages[selectedPackage];
  const baseCost = pkg.pricePerAngler * anglersCount;
  const conservationLevy = 65 * anglersCount;
  const estimatedTotal = baseCost + conservationLevy;

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#070b14',
      color: '#f8fafc',
      fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      overflowX: 'hidden'
    }}>
      {/* 1. SALES DEMO MODE TOP BANNER */}
      <div style={{
        background: 'linear-gradient(90deg, #1e3a8a 0%, #0369a1 50%, #b45309 100%)',
        color: '#ffffff',
        padding: '8px 16px',
        fontSize: '12px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{
            background: '#f59e0b',
            color: '#000',
            padding: '2px 8px',
            borderRadius: '999px',
            fontSize: '10px',
            fontWeight: '800',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Sales Demo
          </span>
          <span>
            Simulated Lodge Reservation Portal &bull; Demonstrating TrophyCoin Pre-Registration &amp; Booking Conversion
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <a
            href="/demosite"
            style={{
              color: '#fde68a',
              textDecoration: 'underline',
              fontSize: '12px',
              fontWeight: '700'
            }}
          >
            &larr; Return to Lodge Home
          </a>
          <a
            href="/c/0006ccf49cf46d98"
            target="_blank"
            rel="noreferrer"
            style={{
              background: '#ffffff',
              color: '#0f172a',
              padding: '4px 12px',
              borderRadius: '6px',
              textDecoration: 'none',
              fontSize: '11px',
              fontWeight: '700'
            }}
          >
            🏆 View Sample Card &#8599;
          </a>
        </div>
      </div>

      {/* 2. HEADER WITH BREADCRUMB */}
      <header style={{
        background: 'rgba(11, 19, 41, 0.95)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        padding: '16px 24px'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '14px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '38px',
              height: '38px',
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #1e3a8a 0%, #d4af37 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px'
            }}>
              🎣
            </div>
            <div>
              <div style={{ fontSize: '15px', fontWeight: '800', color: '#fff', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                Fisherman&apos;s Tale Lodge
              </div>
              <div style={{ fontSize: '11px', color: '#d4af37', fontWeight: '600' }}>
                Charter &amp; Suite Reservation Desk
              </div>
            </div>
          </div>

          <a
            href="/demosite"
            style={{
              color: '#cbd5e1',
              textDecoration: 'none',
              fontSize: '13px',
              fontWeight: '600',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '8px 14px',
              borderRadius: '6px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}
          >
            <span>&larr;</span>
            <span>Back to Lodge Site</span>
          </a>
        </div>
      </header>

      {/* 3. MAIN BOOKING FORM CONTAINER */}
      <main style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '40px 20px 80px 20px'
      }}>
        {/* Title & Introductory Badge */}
        <div style={{ marginBottom: '32px' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            background: 'rgba(16, 185, 129, 0.12)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
            color: '#34d399',
            padding: '4px 12px',
            borderRadius: '999px',
            fontSize: '11px',
            fontWeight: '700',
            marginBottom: '12px'
          }}>
            <span>●</span>
            <span>2026/2027 Season Dates Now Open &bull; Instant Confirmation Holds</span>
          </div>
          <h1 style={{
            fontSize: 'clamp(26px, 4vw, 36px)',
            fontWeight: '900',
            color: '#ffffff',
            margin: '0 0 10px 0'
          }}>
            Reserve Your Trophy Angling Expedition
          </h1>
          <p style={{ fontSize: '14px', color: '#94a3b8', margin: 0, maxWidth: '650px', lineHeight: 1.5 }}>
            Customize your dates, lodge suites, target species, and pre-register your group for minted <strong style={{ color: '#fde68a' }}>TrophyCoin&trade; certified keepsakes</strong>.
          </p>
        </div>

        {/* 2-Column Grid: Form Left, Summary Right */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '30px',
          alignItems: 'start'
        }}>
          {/* LEFT: Booking Steps */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            
            {/* STEP 1: PACKAGE SELECTOR */}
            <div style={{
              background: '#0d1322',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '16px',
              padding: '24px'
            }}>
              <div style={{
                fontSize: '11px',
                fontWeight: '800',
                color: '#d4af37',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: '6px'
              }}>
                Step 1 of 4
              </div>
              <h2 style={{ fontSize: '18px', fontWeight: '800', color: '#ffffff', margin: '0 0 16px 0' }}>
                Select Your Expedition Experience
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {Object.entries(packages).map(([key, item]) => {
                  const isSelected = selectedPackage === key;
                  return (
                    <div
                      key={key}
                      onClick={() => setSelectedPackage(key)}
                      style={{
                        background: isSelected ? 'rgba(30, 58, 138, 0.3)' : 'rgba(255, 255, 255, 0.02)',
                        border: isSelected ? '1.5px solid #d4af37' : '1px solid rgba(255, 255, 255, 0.06)',
                        borderRadius: '12px',
                        padding: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.15s',
                        position: 'relative'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                        <div style={{ fontSize: '15px', fontWeight: '800', color: isSelected ? '#fde68a' : '#ffffff' }}>
                          {item.name}
                        </div>
                        <span style={{
                          background: isSelected ? '#d4af37' : 'rgba(255, 255, 255, 0.08)',
                          color: isSelected ? '#000' : '#cbd5e1',
                          padding: '3px 8px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: '800',
                          textTransform: 'uppercase'
                        }}>
                          {item.badge}
                        </span>
                      </div>
                      <p style={{ fontSize: '12.5px', color: '#94a3b8', lineHeight: 1.5, margin: '0 0 10px 0' }}>
                        {item.description}
                      </p>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '11px', color: '#64748b' }}>
                          {item.nights} Nights &bull; {item.charterDays} Charter Days &bull; TrophyCoin Included
                        </div>
                        <div style={{ fontSize: '16px', fontWeight: '800', color: '#ffffff' }}>
                          ${item.pricePerAngler.toLocaleString()} <span style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '400' }}>/ angler</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* STEP 2: DATES & PARTY SIZE */}
            <div style={{
              background: '#0d1322',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '16px',
              padding: '24px'
            }}>
              <div style={{
                fontSize: '11px',
                fontWeight: '800',
                color: '#d4af37',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: '6px'
              }}>
                Step 2 of 4
              </div>
              <h2 style={{ fontSize: '18px', fontWeight: '800', color: '#ffffff', margin: '0 0 16px 0' }}>
                Dates &amp; Angler Details
              </h2>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '18px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                    Arrival Date
                  </label>
                  <input
                    type="date"
                    value={arrivalDate}
                    onChange={(e) => setArrivalDate(e.target.value)}
                    style={{
                      width: '100%',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      borderRadius: '8px',
                      color: '#ffffff',
                      padding: '10px 12px',
                      fontSize: '13px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                    Departure Date
                  </label>
                  <input
                    type="date"
                    value={departureDate}
                    onChange={(e) => setDepartureDate(e.target.value)}
                    style={{
                      width: '100%',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      borderRadius: '8px',
                      color: '#ffffff',
                      padding: '10px 12px',
                      fontSize: '13px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '18px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                  Number of Anglers in Party: <strong style={{ color: '#fde68a' }}>{anglersCount} Angler(s)</strong>
                </label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                    <button
                      key={num}
                      type="button"
                      onClick={() => handleAnglerCountChange(num)}
                      style={{
                        flex: '1 0 34px',
                        height: '38px',
                        background: anglersCount === num ? '#d4af37' : 'rgba(255, 255, 255, 0.05)',
                        color: anglersCount === num ? '#000' : '#ffffff',
                        border: anglersCount === num ? '1px solid #d4af37' : '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: '800',
                        cursor: 'pointer',
                        transition: 'all 0.15s'
                      }}
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                    Primary Target Species
                  </label>
                  <select
                    value={targetSpecies}
                    onChange={(e) => setTargetSpecies(e.target.value)}
                    style={{
                      width: '100%',
                      background: '#080c14',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      borderRadius: '8px',
                      color: '#ffffff',
                      padding: '10px 12px',
                      fontSize: '13px',
                      boxSizing: 'border-box'
                    }}
                  >
                    <option value="tiger_fish">African Tiger Fish (Hydrocynus vittatus)</option>
                    <option value="bream">Trophy River Bream / Tilapia</option>
                    <option value="wild_trout">Rainbow &amp; Brown Trout</option>
                    <option value="salmon">King Salmon</option>
                    <option value="multi_species">Multi-Species Mixed Slam</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                    Charter Fleet Preference
                  </label>
                  <select
                    value={boatType}
                    onChange={(e) => setBoatType(e.target.value)}
                    style={{
                      width: '100%',
                      background: '#080c14',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      borderRadius: '8px',
                      color: '#ffffff',
                      padding: '10px 12px',
                      fontSize: '13px',
                      boxSizing: 'border-box'
                    }}
                  >
                    <option value="jet_boat">Heavy River Jet Boat (Rapids / Heavy Current)</option>
                    <option value="drift_boat">Custom Drift Boat (Fly Fishing / Float)</option>
                    <option value="heli_combo">Jet Boat + Heli-Canyon Combo</option>
                  </select>
                </div>
              </div>
            </div>

            {/* STEP 3: TROPHYCOIN PRE-REGISTRATION (SALES TOOL HIGHLIGHT) */}
            <div style={{
              background: 'radial-gradient(ellipse at 50% 0%, rgba(212, 175, 55, 0.15) 0%, #0d1322 80%)',
              border: '1.5px solid rgba(212, 175, 55, 0.4)',
              borderRadius: '16px',
              padding: '24px',
              position: 'relative'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                <div style={{
                  fontSize: '11px',
                  fontWeight: '800',
                  color: '#fef08a',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}>
                  Step 3 of 4 &bull; TrophyCoin&trade; Partner Feature
                </div>
                <span style={{ fontSize: '18px' }}>🪙</span>
              </div>
              <h2 style={{ fontSize: '18px', fontWeight: '800', color: '#ffffff', margin: '0 0 8px 0' }}>
                Pre-Register Anglers for Minted Keepsake Coins
              </h2>
              <p style={{ fontSize: '12.5px', color: '#cbd5e1', lineHeight: 1.5, margin: '0 0 16px 0' }}>
                Every angler in this package receives an official engraved metallic TrophyCoin. Pre-registering their names enables instant skipper certification on the water.
              </p>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px' }}>
                {guestNames.map((name, idx) => (
                  <div key={idx}>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: '#94a3b8', marginBottom: '4px' }}>
                      Angler #{idx + 1} Name
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => handleNameChange(idx, e.target.value)}
                      placeholder={`Angler #${idx + 1}`}
                      style={{
                        width: '100%',
                        background: 'rgba(0, 0, 0, 0.5)',
                        border: '1px solid rgba(212, 175, 55, 0.3)',
                        borderRadius: '6px',
                        color: '#ffffff',
                        padding: '8px 12px',
                        fontSize: '12.5px',
                        boxSizing: 'border-box'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* STEP 4: CONTACT & SPECIAL REQUESTS */}
            <div style={{
              background: '#0d1322',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '16px',
              padding: '24px'
            }}>
              <div style={{
                fontSize: '11px',
                fontWeight: '800',
                color: '#d4af37',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: '6px'
              }}>
                Step 4 of 4
              </div>
              <h2 style={{ fontSize: '18px', fontWeight: '800', color: '#ffffff', margin: '0 0 16px 0' }}>
                Lead Guest Contact Information
              </h2>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                    Email Address
                  </label>
                  <input
                    type="email"
                    value={contactEmail}
                    onChange={(e) => setContactEmail(e.target.value)}
                    style={{
                      width: '100%',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      borderRadius: '8px',
                      color: '#ffffff',
                      padding: '10px 12px',
                      fontSize: '13px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    value={contactPhone}
                    onChange={(e) => setContactPhone(e.target.value)}
                    style={{
                      width: '100%',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      borderRadius: '8px',
                      color: '#ffffff',
                      padding: '10px 12px',
                      fontSize: '13px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#cbd5e1', marginBottom: '6px' }}>
                  Dietary Restrictions or Special Angling Requests
                </label>
                <textarea
                  rows="3"
                  value={specialRequests}
                  onChange={(e) => setSpecialRequests(e.target.value)}
                  style={{
                    width: '100%',
                    background: 'rgba(0, 0, 0, 0.4)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    borderRadius: '8px',
                    color: '#ffffff',
                    padding: '10px 12px',
                    fontSize: '13px',
                    boxSizing: 'border-box',
                    fontFamily: 'inherit'
                  }}
                />
              </div>
            </div>
          </div>

          {/* RIGHT: Price Calculation Summary & Sticky CTA */}
          <div style={{
            position: 'sticky',
            top: '80px',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}>
            <div style={{
              background: '#0d1322',
              border: '1px solid rgba(212, 175, 55, 0.3)',
              borderRadius: '16px',
              padding: '24px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
            }}>
              <div style={{
                fontSize: '11px',
                fontWeight: '800',
                color: '#d4af37',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: '8px'
              }}>
                Reservation Estimate
              </div>
              <div style={{ fontSize: '20px', fontWeight: '800', color: '#ffffff', marginBottom: '4px' }}>
                {pkg.name}
              </div>
              <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '18px' }}>
                {arrivalDate} &rarr; {departureDate} &bull; {anglersCount} Angler(s)
              </div>

              {/* Itemized Line Items */}
              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.08)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                padding: '14px 0',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                fontSize: '13px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cbd5e1' }}>
                  <span>Expedition Package ({anglersCount}x)</span>
                  <span>${baseCost.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cbd5e1' }}>
                  <span>River Conservation &amp; Catch Levy</span>
                  <span>${conservationLevy.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#fde68a' }}>
                  <span>🏆 Minted TrophyCoin Keepsakes ({anglersCount}x)</span>
                  <span style={{ fontWeight: '700' }}>INCLUDED</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cbd5e1' }}>
                  <span>Master Skipper, Jet Boat &amp; Tackle</span>
                  <span>INCLUDED</span>
                </div>
              </div>

              {/* Total Calculation */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                margin: '18px 0'
              }}>
                <span style={{ fontSize: '15px', fontWeight: '700', color: '#ffffff' }}>Estimated Total:</span>
                <div>
                  <span style={{ fontSize: '26px', fontWeight: '900', color: '#d4af37' }}>
                    ${estimatedTotal.toLocaleString()}
                  </span>
                  <span style={{ fontSize: '11px', color: '#64748b' }}> USD</span>
                </div>
              </div>

              {/* Action Button */}
              <button
                type="button"
                onClick={() => setShowConfirmation(true)}
                style={{
                  width: '100%',
                  background: 'linear-gradient(135deg, #d4af37 0%, #b45309 100%)',
                  color: '#070b14',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '14px',
                  fontSize: '15px',
                  fontWeight: '800',
                  cursor: 'pointer',
                  boxShadow: '0 6px 20px rgba(212, 175, 55, 0.4)',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                <span>Request Reservation Hold</span>
                <span>&rarr;</span>
              </button>

              <div style={{
                fontSize: '11px',
                color: '#64748b',
                textAlign: 'center',
                marginTop: '12px',
                lineHeight: 1.4
              }}>
                🔒 No credit card charged today. Your requested dates will be placed on complimentary 48-hour hold.
              </div>
            </div>

            {/* Why Book Direct Card */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.02)',
              border: '1px solid rgba(255, 255, 255, 0.06)',
              borderRadius: '14px',
              padding: '18px',
              fontSize: '12px',
              color: '#94a3b8'
            }}>
              <div style={{ fontWeight: '700', color: '#ffffff', marginBottom: '8px' }}>
                Why Book With Fisherman&apos;s Tale Lodge?
              </div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li>Certified IGFA &amp; USCG licensed skippers</li>
                <li>Exclusive private access to pristine cataract pools</li>
                <li>Personalized TrophyCoin NFC metallic keepsake coin</li>
                <li>100% sustainable catch-and-release conservation</li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      {/* 4. INTERACTIVE SALES CONFIRMATION MODAL */}
      {showConfirmation && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          zIndex: 2000
        }}>
          <div style={{
            background: '#0f172a',
            border: '1px solid #d4af37',
            borderRadius: '20px',
            maxWidth: '520px',
            width: '100%',
            padding: '32px',
            boxShadow: '0 25px 60px rgba(0, 0, 0, 0.7)',
            textAlign: 'center',
            position: 'relative'
          }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: 'rgba(16, 185, 129, 0.2)',
              color: '#10b981',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px',
              margin: '0 auto 16px auto'
            }}>
              ✓
            </div>

            <div style={{
              display: 'inline-block',
              background: '#f59e0b',
              color: '#000',
              padding: '2px 8px',
              borderRadius: '4px',
              fontSize: '10px',
              fontWeight: '800',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '10px'
            }}>
              Sales Demonstration Triggered
            </div>

            <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#ffffff', margin: '0 0 10px 0' }}>
              Reservation Hold Request Sent!
            </h3>

            <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.6, margin: '0 0 20px 0' }}>
              In a live deployment for your lodge, this event instantly:
            </p>

            <div style={{
              background: 'rgba(0, 0, 0, 0.4)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'left',
              fontSize: '12px',
              color: '#94a3b8',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              marginBottom: '24px'
            }}>
              <div>
                <strong style={{ color: '#fff' }}>1. Alerts Concierge:</strong> Dispatches reservation payload to `concierge@fishermanstale.com` and your lodge PMS.
              </div>
              <div>
                <strong style={{ color: '#fff' }}>2. Holds Dates:</strong> Places calendar hold for <strong>{anglersCount} Angler(s)</strong> ({arrivalDate} &rarr; {departureDate}).
              </div>
              <div>
                <strong style={{ color: '#fde68a' }}>3. Pre-Allocates Coins:</strong> Reserves {anglersCount} metallic TrophyCoins in your operator vault for {guestNames.join(', ')}.
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={() => setShowConfirmation(false)}
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: '#ffffff',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  padding: '10px 18px',
                  borderRadius: '8px',
                  fontSize: '13px',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
              >
                Close Modal
              </button>
              <a
                href="/demosite"
                style={{
                  background: 'linear-gradient(135deg, #d4af37 0%, #b45309 100%)',
                  color: '#070b14',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '800'
                }}
              >
                Return to Demo Lodge &rarr;
              </a>
              <a
                href="/c/0006ccf49cf46d98"
                target="_blank"
                rel="noreferrer"
                style={{
                  background: 'rgba(56, 189, 248, 0.15)',
                  border: '1px solid rgba(56, 189, 248, 0.4)',
                  color: '#38bdf8',
                  padding: '10px 18px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '700'
                }}
              >
                View Sample Brag Card &#8599;
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
